import { decamelizeKeys } from "humps";

// reads from DOM csrf token generated by Rails in <%= csrf_meta_tags %>

export const sendServerEvent = (event, eventData, userEmail = null) => {
  return $.ajax({
    url: "/api/v1/facebook_event_tracker",
    type: "POST",
    data: decamelizeKeys({ event, eventData, userEmail }),
    success: response => response,
    error: error => error
  });
};